module.exports = __webpack_public_path__ + "img/api.3076974b.svg";